import { useTranslation } from "react-i18next";
import { HStack, VStack } from "../../../../../styled-system/jsx";
import { Button } from "../../../../components/core/basic/Button";
import { Switch } from "../../../../components/fields/base/Switch";
import { NumberInput } from "../../../../components/fields/base/NumberInput";
import { css } from "../../../../../styled-system/css";

interface DaypartingControlsProps {
  isEnabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  selectedCount: number;
  bidValue: number;
  onBidValueChange: (value: number) => void;
  onApply: () => void;
  onClear: () => void;
  onReset: () => void;
  canUpdate: boolean;
}

export function DaypartingControls({
  isEnabled,
  onEnabledChange,
  selectedCount,
  bidValue,
  onBidValueChange,
  onApply,
  onClear,
  onReset,
  canUpdate,
}: DaypartingControlsProps) {
  const { t } = useTranslation(["advertising", "common"]);
  const hasSelection = selectedCount > 0;

  return (
    <VStack gap="medium" alignItems="flex-start">
      <HStack gap="medium" alignItems="center">
        <Switch isSelected={isEnabled} isDisabled={!canUpdate} onChange={() => onEnabledChange(!isEnabled)}>
          {t(($) => $.advertising["Dayparting"])}
        </Switch>

        {canUpdate && (
          <Button variant="secondary" onPress={onReset}>
            {t(($) => $.advertising["Reset"])}
          </Button>
        )}
      </HStack>

      {isEnabled && hasSelection && (
        <HStack gap="medium" alignItems="flex-end">
          <NumberInput
            label={t(($) => $.advertising["Bid Modifier"])}
            value={bidValue}
            onChange={onBidValueChange}
            step={0.001}
            formatOptions={{ maximumFractionDigits: 3 }}
            minValue={0}
            isDisabled={!canUpdate}
            css={{ width: "120px" }}
          />

          <Button onPress={onApply} isDisabled={!canUpdate}>
            {t(($) => $.advertising["Apply ({selectedCount})"], { selectedCount })}
          </Button>
          <Button variant="secondary" onPress={onClear}>
            {t(($) => $.common.actions.Clear)}
          </Button>
        </HStack>
      )}

      {isEnabled && (
        <small className={css({ color: "grey", fontStyle: "italic" })}>
          {t(
            ($) =>
              $.advertising[
                "Clicking a cell toggles its selection. Drag to select multiple cells. Hold Shift to add to current selection."
              ],
          )}
        </small>
      )}
    </VStack>
  );
}
